// extracted by mini-css-extract-plugin
module.exports = {"l12dq88e":"l12dq88e","l1055i6b":"l1055i6b","m6o2ya":"m6o2ya","m9kudxm":"m9kudxm"};